<app-public-navigation
  [style.display]="shouldHideTopbar ? 'none' : null"
  [menuItems]="arrayMenu"
  [isAuthenticate]="isAuthenticate"
  [nameMenu]="nameMenu"
  [themeClass]="divClass"
  [navClass]="navClass"
  (geoBosquesClick)="irVisorGeoBosques()"
  (loginClick)="utilService.link('inicio-sesion')"
  (logoutClick)="cerrarSesion()"
></app-public-navigation>
<div
  class="topbar-public-spacer"
  [class.topbar-public-spacer--visible]="shouldShowSpacer"
  aria-hidden="true"
></div>